import { FC } from 'react';

import Table from 'modules/_shared/Table';

import OperationsTableHeader from './OperationsTableHeader';
import OperationsTableBody from './OperationsTableBody';

const OperationsTable: FC = () => {
  const tableContent = (
    <>
      <OperationsTableHeader />
      <OperationsTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default OperationsTable;
